import options from './thing-star.component';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./star.json'); // eslint-disable-line global-require
    require('./unstar.json'); // eslint-disable-line global-require
}

export default {
    selector: 'dtThingStar',
    options
};



// WEBPACK FOOTER //
// ./app/common/thing-star/index.js